import React from 'react';
import char from '../assets/img/char.png'
import { motion } from 'framer-motion';

const About = () => {

  const softSkills = ['Critical Thinking','Time Management','Creativity' ,'Attention to Detail','Problem-solving','Teamwork','Adaptability'];

  const techSkills = [
    { title: 'JavaScript', percentage: 85 },
    { title: 'CSS', percentage: 95 },
    { title: 'React', percentage: 40 },
    { title: 'Angular', percentage: 70 },
    { title: 'Node.js', percentage: 75 },
    { title: 'MongoDB', percentage: 60 },
    { title: 'Java', percentage: 65 },
    { title: 'PHP', percentage: 80 },
    { title: 'MySQL', percentage: 80 }
  ];

  
  
  return (
    <section className="about-section" id="aboutme">
      <h1 className='title'>&lt; AboutMe /&gt;</h1>
      <div className='main-container'>
        <div className='flex'>
          <motion.div 
            className='w-50 glass-box below'
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ type: "spring", bounce: 0.5, duration: 3}}
            exit={{ x:-1000, opacity: 0 }}
          >
            <div className='text-description'>
              <p >Hello! I'm <b>Emanuela</b>, an Italian tech enthusiast currently living my life in the Netherlands.</p>

              <p>My journey into the world of technology began in childhood, captivated by computers and their <b>limitless possibilities</b> (and let's be honest, a few games of Mario Kart). This passion led me to earn a <b>degree in Computer Science</b>.</p>

              <p>Since then, I have gained significant <b>hands-on experience</b> in the tech industry, continually refining my skills and expanding my knowledge (code, coffee, repeat!).</p>

              <p>My professional journey has been rich with <b>challenging projects and opportunities</b>, driving my commitment to <b>growth and innovation</b>. I am enthusiastic about applying my expertise, embracing new opportunities, and contributing to <b>cutting-edge tech solutions</b> (with a touch of sparkle, of course!).</p>
              <p>Let's connect!</p>
            </div>
          </motion.div>
          <motion.div
            className='over'
            initial={{ opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ type: "spring", duration: 3}}
            exit={{  opacity: 0 }}
          >
            <div className='image-container'>
              <img src={char} alt="emanuela 3D character" className=''/>
            </div>
          </motion.div>
        </div>
        <div className='flex'>
          <motion.div 
            className='glass-box'
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ type: "spring", bounce: 0.5, duration: 3}}
            exit={{ x: 100, opacity: 0 }}
          >
            <h2>SKILLS</h2>
            <h3>Soft Skills</h3>
            <div className="progress-container soft-skills">
              {softSkills.map((skill, index) => (
                <div key={index} className='badge'>{skill}</div>
              ))}
            </div>
            <h3>Tech Skills</h3>
            <div className="progress-container">
              {techSkills.map((skill, index) => (
                <div key={index} className='skill'>
                  <p className="progress-label">
                    {skill.title}
                  </p>
                  <div className="progress">
                    <div className="progress-value" data-percentage={skill.percentage} style={{ '--progress-width': `${skill.percentage}%` }}></div>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>

    </section>
  );
};

export default About;